export default {
  title: '我的个人信息',
  label: {
    information: '我的个人信息',
    name: '姓名',
    email: '邮箱',
    mobile: '手机帐号',
    id: 'ID',
    myApplication: '我的申请',
    application: '已申请',
    inCompleteApplication: '未完成申请',
    myConsent: '我的授权'
  },
  message: {
    weChatBindSuccess: '绑定成功，当你成功获取推荐奖励后，奖励会自动发放到你的零钱',
    weChatBindFailed: '您的微信账号已绑定了另一个账户，请使用其他微信账号进行绑定。'
  }
}
